import React, { useState } from "react";
import { FaPaperPlane } from "react-icons/fa";
import { motion, AnimatePresence } from "framer-motion";
import logo from "../../assets/logos/TSV-Logo-white.webp";

const SubscribeBanner = () => {
  const [email, setEmail] = useState("");
  const [isSubscribed, setIsSubscribed] = useState(false);
  const [isHovered, setIsHovered] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (email && isValidEmail(email)) {
      // Here you would typically make an API call to subscribe the email
      console.log("Subscribing email:", email);
      setIsSubscribed(true);
      setEmail("");
      
      // Reset after 3 seconds
      setTimeout(() => {
        setIsSubscribed(false);
      }, 3000);
    }
  };

  const isValidEmail = (email) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email);
  };

  return (
    <section className="w-full px-4 sm:px-6 lg:px-12 py-8">
      <motion.div 
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        viewport={{ once: true }}
        className="bg-primaryBtnColor text-white rounded-lg flex flex-col md:flex-row items-center justify-between gap-6 p-6 md:p-8 relative overflow-hidden"
      >
        {/* Animated background elements */}
        <motion.div 
          className="absolute -left-4 -top-4 w-20 h-20 rounded-full bg-white opacity-10"
          animate={{
            scale: [1, 1.2, 1],
            opacity: [0.1, 0.05, 0.1],
          }}
          transition={{
            duration: 4,
            repeat: Infinity,
            ease: "easeInOut"
          }}
        />
        <motion.div 
          className="absolute -right-4 -bottom-4 w-16 h-16 rounded-full bg-white opacity-10"
          animate={{
            scale: [1, 1.3, 1],
            opacity: [0.1, 0.05, 0.1],
          }}
          transition={{
            duration: 5,
            repeat: Infinity,
            ease: "easeInOut",
            delay: 1
          }}
        />
        
        {/* Left - Logo */}
        <motion.div 
          className="flex-shrink-0"
          whileHover={{ scale: 1.05 }}
          transition={{ type: "spring", stiffness: 400, damping: 10 }}
        >
          <img
            src={logo}
            alt="TechSpear Ventures"
            className="h-14 md:h-20"
          />
        </motion.div>

        {/* Middle - Text */}
        <motion.div 
          className="flex flex-col text-center md:text-left"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ delay: 0.2, duration: 0.5 }}
          viewport={{ once: true }}
        >
          <h3 className="text-2xl md:text-3xl font-medium tracking-wide">Subscribe Us 𓂃 𓈒𓏸‪‪</h3>
          <motion.p 
            className="text-sm md:text-base opacity-90 tracking-wider mt-2"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 0.9 }}
            transition={{ delay: 0.4, duration: 0.5 }}
            viewport={{ once: true }}
          >
            Subscribe us to receive market updates.
          </motion.p>
        </motion.div>

        {/* Right - Email Input */}
        <AnimatePresence mode="wait">
          {!isSubscribed ? (
            <motion.form 
              key="email-form"
              initial={{ opacity: 0, x: 20 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: -20 }}
              transition={{ duration: 0.3 }}
              onSubmit={handleSubmit}
              className="flex items-center bg-[#B8CEC4] rounded-md overflow-hidden w-full md:w-1/3"
            >
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Email id here"
                className="flex-1 px-4 py-3 text-white bg-[#B8CEC4] border-r-2 placeholder-white tracking-wide focus:outline-none"
                required
              />
              <motion.button 
                type="submit"
                className="bg-[#B8CEC4] text-primaryBtnColor px-4 py-3"
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.95 }}
                onHoverStart={() => setIsHovered(true)}
                onHoverEnd={() => setIsHovered(false)}
              >
                <motion.div
                  animate={{ rotate: isHovered ? 20 : 0 }}
                  transition={{ type: "spring", stiffness: 500, damping: 10 }}
                >
                  <FaPaperPlane className="text-xl" />
                </motion.div>
              </motion.button>
            </motion.form>
          ) : (
            <motion.div 
              key="success-message"
              initial={{ opacity: 0, scale: 0.8 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0.8 }}
              transition={{ duration: 0.3 }}
              className="bg-green-500 text-white px-6 py-3 rounded-md w-full md:w-1/3 text-center"
            >
              Thank you for subscribing!
            </motion.div>
          )}
        </AnimatePresence>
      </motion.div>
    </section>
  );
};

export default SubscribeBanner;





// import React from "react";
// import { FaPaperPlane } from "react-icons/fa";
// import logo from "../../assets/logos/TSV-Logo-white.webp";

// const SubscribeBanner = () => {
//   return (
//     <section className="w-full px-4 sm:px-6 lg:px-12 py-8">
//       <div className="bg-primaryBtnColor text-white rounded-lg flex flex-col md:flex-row items-center justify-between gap-6 p-6 md:p-8">
        
//         {/* Left - Logo */}
//         <div className="flex-shrink-0">
//           <img
//             src={logo}
//             alt="TechSpear Ventures"
//             className="h-14 md:h-20"
//           />
//         </div>

//         {/* Middle - Text */}
//         <div className="flex flex-col text-center md:text-left">
//           <h3 className="text-2xl md:text-3xl font-medium tracking-wide">Subscribe Us</h3>
//           <p className="text-sm md:text-base opacity-90 tracking-wider mt-2">
//             Subscribe us to receive market updates.
//           </p>
//         </div>

//         {/* Right - Email Input */}
//         <div className="flex items-center bg-[#B8CEC4] rounded-md overflow-hidden w-full md:w-1/3">
//           <input
//             type="email"
//             placeholder="Email id here"
//             className="flex-1 px-4 py-3 text-white bg-[#B8CEC4] border-r-2 placeholder-white tracking-wide focus:outline-none"
//           />
//           <button className="bg-[#B8CEC4] text-primaryBtnColor px-4">
//             <FaPaperPlane className="text-xl" />
//           </button>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default SubscribeBanner;
